   
import { useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/contact-phone2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import emailjs from '@emailjs/browser';

export const QuoteForm = () => {

  const form = useRef();

  const [delMessage, setDelMessage] = useState('')
  
   
  const sendEmail = (e) => {
    e.preventDefault();
   
    emailjs.sendForm('service_0992ipa', 'template_owh1whc', form.current, '67_o2ZZDP1_OUY8sw')
    .then((result) => {
      console.log(result.text);
      setDelMessage('Message Sent Successfully! Expect a feedback soon.')
  }, (error) => {
      console.log(error.text);
      setDelMessage('Message failed to deliver! Please try agin later.')
  });

    e.target.reset();
  };

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <img className={isVisible ? "animate__animated animate__zoomIn" : ""} src={contactImg} alt="Contact Us"/>
              }
            </TrackVisibility>
          </Col>
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h3>Get Started Here</h3>
                <form ref={form} onSubmit={sendEmail}>
                  <Row>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text" required='true' placeholder="First Name" name="first_name" />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text" placeholder="Last Name" name="last_name" />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="email" required='true' placeholder="Email Address" name="user_email"  />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="tel" required='true' placeholder="Phone No." name="user_phone" />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text" required='true' placeholder="Service interested in?  (e.g Graphic design, Web)." name="service_type" />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text" required='true' placeholder="When to begin?" name="time_tostart" />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text" required='true' placeholder="Budget you have in mind?" name="budget_range" />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text" placeholder="Company Name?" name="company_name" />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text" placeholder="Role in the Company?" name="role_incompany" />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text" required='true' placeholder="Location (e.g Port Harcourt)." name="user_location" />
                    </Col>
                    <Col size={12} className="px-1">
                      <textarea rows="6" required='true' placeholder="Tell us more about your business goals" name="message" ></textarea>
                    <Col>
                    <p>{delMessage}</p>
                    </Col>
                      <button type="submit"><span>Get Quote</span></button>
                    </Col>
                    
                  </Row>
                  
                </form>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

